import { Divider, Grid, Typography } from '@material-ui/core';
import React from 'react';

import { Calendar } from '~/src/dash/components/calendar/calendar';
import { IStore } from '~/src/dash/reducers/store';
import { IMenuList } from '~/src/dash/types/menuList';
import { publicaColors } from '~/src/dash/utils/colors';
import { formatWithoutHoursMins } from '~/src/dash/utils/date';
import {
  generateCalendarQuickSelectorCustomOptions,
  generateCalendarQuickSelectorOptions,
  generateItemsFromGroupBys,
  isAnyFilterActive,
} from '~/src/dash/views/common/ias-data-consts';
import { IMeasurementCalendarProps } from '~/src/dash/views/common/ias-data-types';
import { IASMeasurementTrackEvent } from '~/src/dash/views/measurement/common/consts';
import { IMeasurementFilter, IMeasurementTableGroupBy } from '~/src/dash/views/measurement/config';
import { MeasurementFiltersPill } from '~/src/dash/views/measurement/MeasurementDrill/MeasurementFilters/MeasurementFiltersPill';
import { SingleSelect } from '~/src/dash/views/singleselect-view';

interface IMeasurementFiltersProps extends IMeasurementCalendarProps, IStore {
  timezone: string;
  filters: IMeasurementFilter[];
  groupBys: IMeasurementTableGroupBy[];
  currentGroupBy: IMeasurementTableGroupBy;
  handleGroupByOnChange: (name: string, value: string | string[] | number) => void;
  handleFilterOnChange: (menuTitle: string) => (values: IMenuList) => void;
  handleFilterAccept: () => void;
  handleClearFilters: () => void;
}

export const MeasurementFilters = ({
  user,
  session,
  timezone,
  // calendar props
  range1Selected,
  range1DisplaySelected,
  // range2Selected,
  // range2DisplaySelected,
  // compStartDate,
  // compEndDate,
  // compDisplayStartDate,
  // compDisplayEndDate,
  calStartDate,
  calEndDate,
  calDisplayStartDate,
  calDisplayEndDate,
  calFocusedInput,
  // compFocusedInput,
  // calendar functions
  handleChangeAggRangeSelected,
  handleCalendarDateChange,
  handleDateRangeChange,
  handleCalendarFocusedInputChange,
  // isComparedToEnabled,
  // handleCompareEnabled,
  // filters
  filters,
  groupBys,
  currentGroupBy,
  handleGroupByOnChange,
  handleFilterOnChange,
  handleFilterAccept,
  handleClearFilters,
}: IMeasurementFiltersProps) => {
  // HIDDEN FOR V2
  // const compareQuickSelectorOptions: ICalendarQuickSelectorOptions[] = [
  //   {
  //     title: 'Previous Period',
  //     date1: () => findCompareStartDate({
  //       timezone,
  //       startDate: calDisplayStartDate,
  //       endDate: calDisplayEndDate,
  //       rangeSelected: range1DisplaySelected,
  //     }),
  //     date2: () => findCompareEndDate({
  //       timezone,
  //       startDate: calDisplayStartDate,
  //       endDate: calDisplayEndDate,
  //       rangeSelected: range1DisplaySelected,
  //     }),
  //   },
  //   {
  //     title: 'Last Month',
  //     date1: () => moment(calDisplayStartDate).tz(timezone).subtract(1, 'months'),
  //     date2: () => moment(calDisplayEndDate).tz(timezone).subtract(1, 'months'),
  //   },
  // ];

  // const compareQuickSelectorCustomOptions: ICalendarQuickSelectorOptions[] = [
  //   { title: ' Days Ago, Same Period', date1: (value: string) => moment(calDisplayStartDate).tz(timezone).subtract(parseInt(value, 10), 'days'), date2: (value: string) => moment(calDisplayEndDate).tz(timezone).subtract(parseInt(value, 10), 'days') },
  //   { title: ' Weeks Ago, Same Period', date1: (value: string) => moment(calDisplayStartDate).tz(timezone).subtract(parseInt(value, 10), 'weeks'), date2: (value: string) => moment(calDisplayEndDate).tz(timezone).subtract(parseInt(value, 10), 'weeks') },
  //   { title: ' Months Ago, Same Period', date1: (value: string) => moment(calDisplayStartDate).tz(timezone).subtract(parseInt(value, 10), 'months'), date2: (value: string) => moment(calDisplayEndDate).tz(timezone).subtract(parseInt(value, 10), 'months') },
  // ];

  // const isCalDayHighlighted = (day: moment.Moment): boolean => {
  //   if (!isComparedToEnabled) { return false; }
  //   return formatDateFromUTCToOffset(day.format('YYYY-MM-DDTHH:mm:ss'), 'UTC').isBetween(compDisplayStartDate, compDisplayEndDate, 'day', '[]');
  // };

  // const isCompDayHighlighted = (day: moment.Moment): boolean => {
  //   return formatDateFromUTCToOffset(day.format('YYYY-MM-DDTHH:mm:ss'), 'UTC').isBetween(calDisplayStartDate, calDisplayEndDate, 'day', '[]');
  // };

  return (
    <Grid container direction='column' spacing={2}>
      {/* Row One */}
      <Grid
        item
        container
        spacing={1}
        justify='flex-start'
        alignItems='center'
        style={{
          paddingTop: 0,
          height: 38,
          marginTop: -8,
        }}
      >
        <Grid item style={{ paddingRight: 12, marginTop: 4 }}>
          <img src='/assets/shared/svg/Calendar.svg' />
        </Grid>
        <Grid item justify='flex-start' style={{ paddingRight: 12 }}>
          <Typography style={{ fontSize: 14, fontWeight: 500 }}>Period</Typography>
        </Grid>
        <Grid item justify='flex-start'>
          <Typography style={{ fontSize: 12 }}>{range1DisplaySelected}</Typography>
        </Grid>
        <Grid item>
          <Calendar
            startDate={calStartDate}
            endDate={calEndDate}
            calStartDate={calDisplayStartDate}
            calEndDate={calDisplayEndDate}
            startDateID='startDate'
            endDateID='endDate'
            rangeSelected={range1Selected}
            handleRangeSelected={handleChangeAggRangeSelected}
            handleCalendarDateChange={handleCalendarDateChange(false)}
            handleDateRangeChange={handleDateRangeChange}
            quickSelectorOptions={generateCalendarQuickSelectorOptions(timezone)}
            quickSelectorCustomOptions={generateCalendarQuickSelectorCustomOptions(timezone)}
            // isDayHighlighted={isCalDayHighlighted}
            // @ts-ignore REMOVE THIS IGNORE ONCE COMPARE CALENDAR IS NEEDED & REPLACE LINE BELOW WITH LINE ABOVE
            isDayHighlighted={() => false}
            isCompareCalendar={false}
            focusedInput={calFocusedInput || null}
            excludeToday={true}
            dateFormat={formatWithoutHoursMins(session.publisher.Localization)}
            handleFocusedInputChange={handleCalendarFocusedInputChange(false)}
            trackOnClose={() =>
              IASMeasurementTrackEvent(user.user, {
                eventTitle: 'IAS Measurement Drill Dashboard - Open Calendar',
              })
            }
            timezone={timezone}
            anchorDirection='left'
          />
        </Grid>
        {/* HIDDEN FOR V2 */}
        {/* <Grid item>
          <Checkbox size='small'
            checked={isComparedToEnabled}
            onChange={handleCompareEnabled}
          />
        </Grid>
        <Grid item>
          <Typography style={{ fontSize: 12 }}>
            {range2DisplaySelected}
          </Typography>
        </Grid> */}
        {/* <Grid item> */}
        {/* Comparison Calendar */}
        {/* <Calendar
            startDate={compStartDate}
            endDate={compEndDate}
            calStartDate={compDisplayStartDate}
            calEndDate={compDisplayEndDate}
            startDateID='startDate'
            endDateID='endDate'
            rangeSelected={range2Selected}
            handleRangeSelected={handleChangeAggRangeSelected}
            handleCalendarDateChange={handleCalendarDateChange(true)}
            handleDateRangeChange={handleDateRangeChange}
            quickSelectorOptions={compareQuickSelectorOptions}
            quickSelectorCustomOptions={compareQuickSelectorCustomOptions}
            isDayHighlighted={isCompDayHighlighted}
            isCompareCalendar={true}
            focusedInput={compFocusedInput || null}
            dateFormat={formatWithoutHoursMins(session.publisher.Localization)}
            handleFocusedInputChange={handleCalendarFocusedInputChange(true)}
            trackOnClose={() => IASMeasurementTrackEvent('IAS Publisher Dashboard - Open Compare Calendar')} // TODO: FIX THIS
            timezone={timezone}
            anchorDirection='left'
          /> */}
        {/* </Grid> */}
      </Grid>
      <Grid item>
        <Divider
          variant='fullWidth'
          style={{ height: '1px', padding: 0 }}
          orientation='horizontal'
        />
      </Grid>
      {/* Row Two */}
      <Grid
        item
        container
        justify='flex-start'
        alignItems='center'
        spacing={1}
        direction='row'
        style={{
          marginTop: '-14px',
          height: 48,
        }}
      >
        <Grid item container style={{ maxWidth: '90px' }} xs={1}>
          <Grid item style={{ paddingTop: 2 }}>
            <img src='/assets/shared/svg/FilterDropdownRoot.svg' />
          </Grid>
          <Grid item style={{ paddingLeft: 16 }}>
            <Typography style={{ fontSize: 14, fontWeight: 500 }}>Filters</Typography>
          </Grid>
        </Grid>
        <Grid item container direction='row' justify='flex-start' xs={10}>
          {filters.map((filter) => (
            <MeasurementFiltersPill
              user={user.user}
              menuTitle={filter.menuTitle}
              list={filter.list}
              handleFilterOnChange={handleFilterOnChange}
              handleFilterAccept={handleFilterAccept}
            />
          ))}
          {isAnyFilterActive(filters) && (
            <Grid item onClick={handleClearFilters} style={{ marginLeft: 8, paddingTop: 6 }}>
              <Typography
                style={{
                  fontSize: '0.875rem',
                  fontWeight: 400,
                  color: publicaColors.lightBlue,
                  textTransform: 'none',
                  cursor: 'pointer',
                }}
              >
                Clear
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item>
        <Divider
          variant='fullWidth'
          style={{ height: '1px', padding: 0 }}
          orientation='horizontal'
        />
      </Grid>
      {/* Row Three */}
      <Grid
        item
        container
        justify='flex-start'
        alignItems='center'
        spacing={2}
        direction='row'
        style={{
          paddingTop: 0,
          height: 56,
          marginTop: -16,
        }}
      >
        <Grid item>
          <Grid item container style={{ width: 240, alignItems: 'flex-end' }}>
            <Grid item style={{ marginLeft: -2, paddingBottom: 2 }}>
              <img src='/assets/shared/svg/Map.svg' height='22px' />
            </Grid>
            <Grid
              item
              style={{
                paddingLeft: 12,
                paddingRight: 16,
                paddingBottom: 8,
              }}
            >
              <Typography
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                View By
              </Typography>
            </Grid>
            <Grid item>
              <SingleSelect
                name='View By'
                label=''
                onChange={handleGroupByOnChange}
                items={generateItemsFromGroupBys(groupBys)}
                value={currentGroupBy.dataKey}
                style={{
                  fontSize: '13px',
                  minWidth: '120px',
                  marginTop: '6px',
                  marginBottom: '4px',
                }}
                key={currentGroupBy.dataKey}
                disableAlphanumSort
              />
            </Grid>
          </Grid>
        </Grid>
        {/* HIDDEN FOR V2 */}
        {/* <Grid item>
          <Grid
            item
            container
            style={{ width: 240, alignItems: 'flex-end' }}
          >
            <Grid item style={{ paddingBottom: 6 }}>
              <img src='/assets/shared/svg/ViewDataBy.svg'/>
            </Grid>
            <Grid
              item
              style={{
                paddingLeft: 6,
                paddingRight: 16,
                paddingBottom: 8,
              }}
            >
              <Typography
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                Break By
              </Typography>
            </Grid>
            <Grid item>
              <SingleSelect
                name='Break By'
                label=''
                onChange={}
                items={}
                value={}
                style={{ fontSize: '13px', minWidth: '120px', marginTop: '6px', marginBottom: '4px' }}
              />
            </Grid>
          </Grid>
        </Grid> */}
      </Grid>
    </Grid>
  );
};
